import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { apiOrganization } from "../../../../../../../../../../../../services/Api/Organization/apiOrganization";
import { PurchaseCorrectionApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { PurchaseContext } from "../../../../pages/Preview";
import PurchaseCorrectionForm from "../../components/Form/PurchaseCorrectionForm";
import { purchaseCorrectionInclude } from "../../components/Form/utils";

interface MatchParams {
	correctionId: string;
}

const OrganizationOrderPurchaseCorrectionEditPage = () => {
	const { purchaseCorrectionCustomFieldsConfig, purchase } = useContext(PurchaseContext);
	const { correctionId } = useParams<MatchParams>();
	const { addFlash } = useFlash();
	const [correction, setCorrection] = useState<PurchaseCorrectionApi | undefined>();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		fetchCorrection();
	}, [correctionId]);

	const fetchCorrection = async () => {
		setLoading(true);
		try {
			const res = await apiOrganization.getPurchaseCorrection(purchase.id, Number(correctionId), {
				include: purchaseCorrectionInclude,
			});
			setCorrection(res);
			handleChangeTabTitle(
				`${purchase.document_number} | ${t("modules.purchase.header.title")} | ${t(
					"modules.purchase.field.correction.title"
				)} | ${res.number}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setLoading(false);
	};

	if (!correction || !purchaseCorrectionCustomFieldsConfig || loading) return <LoadingContainer />;

	return (
		<div className="mt-4">
			<Header title={`${t("modules.purchase.field.correction.title")} ${correction.number}`} />
			<PurchaseCorrectionForm
				purchaseCorrectionCustomFieldsConfig={purchaseCorrectionCustomFieldsConfig}
				correction={correction}
				setCorrection={setCorrection}
			/>
		</div>
	);
};

export default OrganizationOrderPurchaseCorrectionEditPage;
